module.exports = __webpack_public_path__ + "img/407.2d9344a6.png";